import { apiObjUrl } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { ZUid } from "src/types/zUid";
import { zAvaliableCopyAttrData } from "./CopyByValueEdit.types";

export const loadCbvLinkAttributes = async (
  objectId: ZUid,
  valueType: number,
) => {
  const resp = await rest.get(apiObjUrl("/objects/info-for-copy-by-value"), {
    params: { objectId, valueType },
  });
  return zAvaliableCopyAttrData.array().parse(resp.data);
};
